import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Table from "../../components/Table";
import Layout from "../../components/Layout";

import { subscriptionsTabs as tabs } from "../../components/Subscription/utils";
import SubscriptionStatusBadge from "../../components/Subscription/SubscriptionStatusBadge";
import SubscriptionBulkActions from "../../components/Subscription/SubscriptionBulkActions";

export default function ManageSubscriptionsPage() {
  const router = useRouter();
  const { created } = router.query;

  const [subscriptionCreated, setSubscriptionCreated] = useState(false);

  useEffect(() => {
    setSubscriptionCreated(created === "true");
  }, [created]);
  return (
    <Layout metaTitle="Manage Subscriptions">
      <Table
        url="/d/subscriptions/"
        tableName="subscription"
        tableTitle="Manage all your subscriptions"
        tableDescription="Manage your customers' subscriptions, check the status of each, take needed actions, create new subscriptions and get paid regularly."
        getPreviewPath={(row) => `/subscriptions/${row.id}`}
        enableRowClickNavigation
        BulkActionsComponent={SubscriptionBulkActions}
        tabs={tabs}
        customRender={{
          status: SubscriptionStatusBadge,
        }}
        onAddItemClick={() => {
          router.push({
            pathname: "/subscriptions/add",
          });
        }}
        itemAddedSuccessfullyMessage={
          subscriptionCreated
            ? "Subscription has been created successfully!"
            : ""
        }
      />
    </Layout>
  );
}

ManageSubscriptionsPage.parentPath = "/subscriptions";
